import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import CardModal from "../CardModal";
import { Dropdown } from "react-bootstrap";

const TodayPicks = (props) => {
  const data = props.data;

  const [visible, setVisible] = useState(8);
  const showMoreItems = () => {
    setVisible((prevValue) => prevValue + 4);
  };

  const [modalShow, setModalShow] = useState(false);

  return (
    <Fragment>
      <section className="tf-section sc-explore-1">
        <div className="themesflat-container">
          <div className="row">
            <div className="col-md-12">
              <div className="wrap-box explore-1 flex mg-bt-40">

                <div className="seclect-box style-2 box-right">
                  <div id="sort-by" className="dropdown">
                    <Dropdown>
                      <Dropdown.Toggle id="dropdown-basic">
                        Sort by
                      </Dropdown.Toggle>

                      <Dropdown.Menu style={{ margin: 0 }}>
                        <Dropdown.Item href="#">Top rate</Dropdown.Item>
                        <Dropdown.Item href="#">Mid rate</Dropdown.Item>
                        <Dropdown.Item href="#">Low rate</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </div>
            {data.slice(0, visible).map((item, index) => (
              <div
                key={index}
                className="fl-item col-xl-3 col-lg-4 col-md-6 col-sm-6"
              >
                <div className="sc-card-product menu_card style-h7">
                      <div className="meta-info style">
                          <Link to="#" className="wishlist-button available"></Link>
                          <Link to="#" className="wishlist-button lock"></Link>
                      </div>
                      <div className="card-media">
                          <Link to="/item-details-01"><img src={item.img} alt="Axies" /></Link>
                      </div>
                      <div className="card-title">
                          <h6><Link to="item-details.html">{item.title}</Link></h6>
                          <div className="phase">
                              <span className="pricing">{item.phase}</span>
                          </div>
                      </div>
                      <div className="meta-info">
                          <div className="author">
                              <div className="info">
                                  <span className="pricing">{item.tags}</span>
                              </div>
                          </div>
                          <div className="author">
                              <div className="info">
                                  <span className="pricing">{item.item_float}</span>
                              </div>
                          </div>

                      </div>
                      <div className="meta-info">
                          <div className="author">
                              <div className="info">
                                  <span>Price</span>
                                  <span className="pricing">{item.price}</span>
                              </div>
                          </div>
                          <div className="discount-percent">-{item.discount}%</div>
                      </div>
                      <div className="card-bottom">
                          <button className="sc-button style fl-button pri-3 no-bg trash">
                              <i class="fa fa-trash"></i>
                          </button>
                          <button onClick={() => setModalShow(true)} className="sc-button fl-button pri-3 no-bg"><span>Buy Now</span></button>
                      </div>
                  </div>
              </div>
            ))}
            {visible < data.length && (
              <div className="col-md-12 wrap-inner load-more text-center">
                <Link
                  to="#"
                  id="load-more"
                  className="sc-button loadmore fl-button pri-3"
                  onClick={showMoreItems}
                >
                  <span>Load More</span>
                </Link>
              </div>
            )}
          </div>
        </div>
      </section>
      <CardModal show={modalShow} onHide={() => setModalShow(false)} />
    </Fragment>
  );
};

TodayPicks.propTypes = {
  data: PropTypes.array.isRequired,
};

export default TodayPicks;
